export interface ProfileDanceStyleInterface {
  translationKey: string;
  experience: number;
  isLeader?: boolean;
  isFollower?: boolean;
  isPairDance?: boolean;
}
